import { helper } from '@ember/component/helper';
import { assert } from '@ember/debug';

const reason = "the 'cancel-all' template helper was invoked";

export const cancelHelper = ([cancelable, resetState = true]) => {
  if (typeof cancelable?.cancelAll !== 'function') {
    assert(`The first argument passed to the \`cancel-all\` helper should be a Task or TaskGroup (without quotes); you passed ${cancelable}`, false);
  }

  return () => cancelable.cancelAll({ resetState, reason });
};

export default helper(cancelHelper);
